export default __webpack_public_path__ + "0f0a8769ec7566eced593abdb1aeb5a6.svg";